module.exports = __webpack_public_path__ + "cancellara-dist/img/hero-splash-2.9deba1f9.jpeg";